"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BuyButton = void 0;
var AddToBasketEvent = _interopRequireWildcard(require("@ori-events/add-to-basket"));
var _components = require("@ori-ui/components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("./constants");
var _hooks = require("./hooks");
var _styles = require("./styles");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ARIA_LABEL = 'aria-label';
const BuyButton = ({
  buyTitle,
  disabledQuantity,
  reserveTitle,
  formattedPrice,
  productCode,
  productName,
  disabled: propsDisabled,
  loading: propsLoading,
  loadingEvents,
  maxValue: propsMaxValue,
  initialQuantity,
  isReserve,
  onlyButton,
  placement,
  className,
  onClick: propsOnClick
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    counterValue,
    disabled: shoppingPropsDisabled,
    loading: shoppingPropsLoading,
    maxQuantity: shoppingPropsMaxQuantity,
    setCounterValue
  } = (0, _hooks.useShoppingProps)({
    initialQuantity,
    loadingEvents,
    productCode
  });
  const maxQuantity = propsMaxValue ?? shoppingPropsMaxQuantity;
  const onCounterBlur = (0, _react.useCallback)(() => {
    if (counterValue === undefined || counterValue === '' || counterValue === '-') {
      setCounterValue(_constants.COUNTER_MIN_VALUE);
    }
  }, [counterValue, setCounterValue]);
  const onCounterChange = (0, _react.useCallback)(currentValue => {
    const count = (0, _utils.parseCounterValue)(currentValue);
    if (count === undefined) {
      setCounterValue('');
    } else {
      setCounterValue(count > maxQuantity ? maxQuantity : count);
    }
  }, [maxQuantity, setCounterValue]);
  const onBuyButtonClick = (0, _react.useCallback)(() => {
    const quantity = (0, _utils.parseCounterValue)(counterValue);
    if (quantity == null) {
      return;
    }
    if (propsOnClick) {
      propsOnClick(quantity);
    } else {
      window.dispatchEvent(new CustomEvent(AddToBasketEvent.Name, {
        detail: {
          itemCode: productCode,
          quantity,
          localName: productName,
          placement,
          formattedPrice: formattedPrice ?? '',
          globalName: ''
        }
      }));
    }
  }, [counterValue, formattedPrice, placement, productCode, productName, propsOnClick]);
  const loading = Boolean(propsLoading) || shoppingPropsLoading;
  const disabled = (0, _react.useMemo)(() => Boolean(propsDisabled) || shoppingPropsDisabled || loading, [loading, propsDisabled, shoppingPropsDisabled]);
  const testId = (0, _react.useMemo)(() => getTestId(isReserve ? _constants.RESERVE_BUTTON : _constants.BUY_BUTTON), [getTestId, isReserve]);
  return onlyButton ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
    fullWidth: true,
    className: className,
    "data-testid": testId,
    variant: "contained",
    color: "primary",
    disabled: disabled,
    loading: loading,
    onClick: onBuyButtonClick,
    children: isReserve ? reserveTitle : buyTitle
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.SplitButton, {
    fullWidth: true,
    className: className,
    buttonContent: isReserve ? reserveTitle : buyTitle,
    disabled: disabled,
    "data-testid": testId,
    loading: loading,
    size: "medium",
    onClick: onBuyButtonClick,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.QuantityPicker, {
      expandOnFocus: true,
      "data-testid": getTestId(_constants.BUY_BUTTON_COUNTER),
      disabled: disabled || disabledQuantity,
      maxValue: maxQuantity,
      minValue: _constants.COUNTER_MIN_VALUE,
      size: "large",
      value: counterValue,
      variant: "text",
      DecreaseIconButtonProps: {
        [ARIA_LABEL]: '-'
      },
      IncreaseIconButtonProps: {
        [ARIA_LABEL]: '+'
      },
      InputProps: {
        inputProps: {
          [ARIA_LABEL]: 'Quantity'
        }
      },
      onBlur: onCounterBlur,
      onChange: onCounterChange
    })
  });
};
exports.BuyButton = BuyButton;
